import React from "react"
import CheckBox from "../../components/common/form/CheckBox.js"
import CheckBoxInline from "../../components/common/form/CheckBoxInline.js"
import RadioInline from '../../components/common/form/RadioInline.js';
import Radio from '../../components/common/form/Radio.js';
import { Editor } from "react-draft-wysiwyg"
import ViewEditor from "../../components/common/editor/ViewEditor";
import { connect } from "react-redux"
import { convertFromRaw, EditorState } from "draft-js"
import {
  getAllQuestionContents,
  getAllAnswerContents,
  getAllCandidateAnswerContents,
  getTestQuestionContent,
  loadAssessmentQuestions,
  loadQuestions,
  getAutoShuffleFlag,
  getCandidateAnswers,
  clearCandidateAnswers,
} from "../../actions/candidate/testActions.js"
import { AzureStorage } from "../../helper/azureStorage.js"
import Spinner from "../../components/Spinner3.js";
import {
  openAssessment
} from "../../actions/candidate/examActions.js"
import ContentWrapper from "../../components/common/ContentWrapper.js"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import "./Questions.css"
import Card from "../../components/common/Card.js"
import CardHeader from "../../components/common/CardHeader.js"
import CardTitle from "../../components/common/CardTitle.js"
import { Button } from "@mui/material"
import AttachmentButton from "../../components/common/AttachmentButton.js"
import { questionMCQAnswerTypeConstants, questionTypeConstants } from "../../helper/constants.js"
import config from "../../helper/config.js"
import { customerConstants } from "../../helper/constants.js"
import AssessmentInfoCard from "../assessment/components/AssessmentInfoCard.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag
}

let addBtnStyle, closeBtnStyle, textColor
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    textColor = "var(--maincolor)"
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor)",
      borderColor: "transparent",
      boxShadow: "none",
      textTransform: "Unset",
      fontFamily: "Poppins",
    }
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
      boxShadow: "none",
    }
    textColor = "var(--maincolor-cmc)"
    break
  default:
    textColor = "var(--maincolor)"
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor)",
      borderColor: "transparent",
      boxShadow: "none",
      textTransform: "Unset",
      fontFamily: "Poppins",
    }
    break
}

class PaperReview extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contentMap: {},
      questions: "",
      questionContents: null,
      assessmentQuestions: "",
      answerContents: null,
      marksSheetMap: {},
      correctAnswer: 0.0,
      paperViewLoading: false,
      groupedQuestions: {},
    }

    this.getQuestionanswer = this.getQuestionanswer.bind(this)
    this.getSumOfMarkAllocation = this.getSumOfMarkAllocation.bind(this)
    this.getSumOfMarkObtained = this.getSumOfMarkObtained.bind(this)
    this.onDownloadAttachment = this.onDownloadAttachment.bind(this)
    this.generateGroupedQuestions = this.generateGroupedQuestions.bind(this)
    this.getSelectedQuestionIdsForMarking = this.getSelectedQuestionIdsForMarking.bind(this);
  }

  async componentDidMount() {
    if (window.KTApp) window.KTApp.initComponents()
    this.setState({ paperViewLoading: true });
    await this.props.loadAssessmentQuestions(this.props.candidate?.assessment_id)
    await this.props.getAllQuestionContents({
      questions: this.props.assessmentQuestions,
    })
    await this.props.getAllAnswerContents({
      questions: this.props.assessmentQuestions,
    })
    await this.props.getCandidateAnswers(this.props.candidate)
    await this.props.getAllCandidateAnswerContents({
      answers: this.props.candidateAnswers,
    })
    if(this.props.sections && this.props.sections.length > 0){
      this.generateGroupedQuestions();
    }
    this.setState({ questions: this.props.assessmentQuestions })
    this.setState({ questionContents: this.props.questionContents })
    this.setState({ answerContents: this.props.answerContents })
    await this.props.assessmentQuestions?.map(async (question, j) => {
      let map = this.state.marksSheetMap
      map[question["question_number"]] = question
      if (question.question_type === questionTypeConstants.MCQ.name) {
        let answerContent = question["answer"].toString().split(",")
        let val = "0",
          correctAnswer = this.state.correctAnswer
        if (parseFloat(answerContent[j]) > 0) {
          val = "1"
          this.setState({ correctAnswer: answerContent[j] }, () => {
            map[question["question_number"]]["correctAnswer"] =
              this.state.correctAnswer
            this.setState({ marksSheetMap: map })
          })
        } else if (parseFloat(answerContent[j]) < 0) {
          val = "-1"
        }
      } else if (
        question.question_type === questionTypeConstants.DESCRIPTIVE.name ||
        question.question_type === questionTypeConstants.SUBMISSION.name ||
        question.question_type === questionTypeConstants.SUBQUESTION.name
      ) {
        let answerContent = question["answer"]
        this.setState({ correctAnswer: answerContent }, () => {
          map[question["question_number"]]["correctAnswer"] =
            this.state.correctAnswer
          this.setState({ marksSheetMap: map })
        })
      }
      this.setState({ marksSheetMap: map })
    })
    this.setState({ paperViewLoading: false });
  }

  componentWillUnmount() {
    this.props.clearCandidateAnswers()
  }

  generateGroupedQuestions() {
    const grouped = {};

    this.props.assessmentQuestions.forEach((question, index) => {
      const sectionMeta = this.props.sections?.find(
        s => s.section_id === question.section_id
      ) || {};

      const partId = sectionMeta.part_id || "default_part";
      const sectionId = question.section_id || "default_section";

      if (!grouped[partId]) {
        grouped[partId] = {
          name: sectionMeta.part_name || `Part ${partId}`,
          allow_part_instruction: sectionMeta.allow_part_instruction,
          part_instruction: sectionMeta.allow_part_instruction ? sectionMeta.part_instruction : "",
          part_display_order: sectionMeta.part_display_order,
          sections: {}
        };
      }

      if (!grouped[partId].sections[sectionId]) {
        grouped[partId].sections[sectionId] = {
          title: sectionMeta.section_title || `Section ${sectionId}`,
          allow_section_instruction: sectionMeta.allow_section_instruction,
          section_instruction: sectionMeta.allow_section_instruction ? sectionMeta.section_instruction : "",
          section_display_order: sectionMeta.section_display_order,
          questions: []
        };
      }

      grouped[partId].sections[sectionId].questions.push({
        data: question,
        index
      });
    });

    this.setState({ groupedQuestions: grouped });
  }

  async onDownloadAttachment(e, container, attach) {
    e.preventDefault()
    let fileReader
    async function handleFileRead() {
      const content = fileReader.result
    }

    fileReader = new FileReader()
    fileReader.onloadend = handleFileRead
    let content = await AzureStorage.downloadBlob(container, attach)
    fileReader.readAsArrayBuffer(content)
  }

  getColor(val) {
    switch (val) {
      case "-1":
        return "label label-lg label-light-danger label-inline"
      case "1":
        return "label label-lg label-light-success label-inline"
      default:
        return ""
    }
  }

  getQuestionPassageContent = (content) => {
    let states = JSON.parse(content);
    let passageContentState = EditorState.createWithContent(convertFromRaw(states[0]));
    return passageContentState;
  }

  getContentInEditor(el, i) {
    var question_type = this.props.assessmentQuestions[i].question_type
    var is_sub = this.props.assessmentQuestions[i].is_subquestion
    let states = JSON.parse(this.props.questionContents[i])
    let tempAnswerStates = []
    let mark_allocation = this.state.marksSheetMap[i + 1]?.mark_allocation
    let tempQuestionState = EditorState.createWithContent(
      convertFromRaw(states[0])
    )
    const isOptional = this.props.assessmentQuestions[i]?.is_optional;
    const questionId = this.props.assessmentQuestions[i]?.question_id;
    const isIncluded = this.getSelectedQuestionIdsForMarking().has(questionId);
    if (question_type === questionTypeConstants.DESCRIPTIVE.name) {
      return (
        <div>
          {this.props.assessmentQuestions[i]?.is_passage === true && this.props.assessmentQuestions[i]?.passage_id !== null && this.props.assessmentQuestions[i]?.passage_content !== undefined &&
            <div className="mb-5 mt-5">
              <ViewEditor
                editorState={this.getQuestionPassageContent(this.props.assessmentQuestions[i]?.passage_content)}
              />
            </div>
          }
          <div className="row mb-5">
            <div className="col-md-10 col-10">
              <h5 className="m-0">
                {el.mainAnsCount}.
                {/* {el.mainAnsCount}. {this.props.assessmentQuestions[i]?.title} */}
              </h5>
            </div>
            <div className="col-md-2 col-2 d-flex align-items-center justify-content-end">
              {/* Label Section */}
              {this.props.sections.length > 0 && 
              <div>
                {isOptional && isIncluded && (
                  <span className="badge badge-success mr-2">Optional Question - Marks included in Total</span>
                )}
                {isOptional && !isIncluded && (
                  <span className="badge badge-primary mr-2">Optional Question - Marks omitted in Total</span>
                )}
              </div>}
              <p className="stu-variant-class label label-lg label-success label-inline">
                {/* Marks:{" "} */}
                {
                  this.props.candidateAnswerMap[
                    this.props.assessmentQuestions[i]?.question_id
                  ]?.mark_obtained
                }
                /{mark_allocation}
              </p>
            </div>
          </div>
          <h3 className="m-0 overflow-hidden">
            <p className="col-md-12 col-12 answer-sheet-text">
              <ViewEditor editorState={tempQuestionState} />
            </p>
          </h3>
          {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
        </div>
      )
    } else if (
      question_type === questionTypeConstants.SUBQUESTION.name &&
      is_sub !== "true"
    ) {
      let subs = this.props.assessmentQuestions[i]?.sub_questions;
      let sub_ques = subs.split(",");
      let sub_questions = {};

      this.props.assessmentQuestions.forEach((item, index) => {
        if (sub_ques.includes(item.question_id.toString())) {
          sub_questions[index] = item;
        }
      });

      let sub_marks = 0;
      let total_sub_marks = 0;
      for (let mark in sub_questions) {
        sub_marks +=
          this.props.candidateAnswerMap[
            this.props.assessmentQuestions[mark]?.question_id
          ]?.mark_obtained || 0;
        total_sub_marks +=
          this.props.assessmentQuestions[mark]?.mark_allocation || 0;
      }

      return (
        <div>
          {/* Main Question Passage */}
          {this.props.assessmentQuestions[i]?.is_passage === true &&
            this.props.assessmentQuestions[i]?.passage_id !== null &&
            this.props.assessmentQuestions[i]?.passage_content !== undefined && (
              <div className="mb-5 mt-5">
                <ViewEditor
                  editorState={this.getQuestionPassageContent(
                    this.props.assessmentQuestions[i]?.passage_content
                  )}
                />
              </div>
            )}

          {/* Main Question Title + Marks */}
          <div className="row mb-5">
            <div className="col-md-9 col-9">
              <h5 className="m-0">{el.mainAnsCount}.</h5>
            </div>
            <div className="col-md-3 col-3 d-flex align-items-center justify-content-end">
              <p className="stu-variant-class label label-lg label-light-success label-inline">
                {sub_marks}/{total_sub_marks}
              </p>
            </div>
          </div>

          {/* Main Question Content */}
          <h3 className="m-0 mb-5 overflow-hidden">
            <p className="col-md-12 col-12 answer-sheet-text">
              <ViewEditor editorState={tempQuestionState} />
            </p>
            <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
          </h3>

          {/* Render Sub Questions */}
          {Object.entries(sub_questions).map(([key, val], j, arr) => {
            const states = JSON.parse(this.props.questionContents[key]);
            const marks =
              this.state.marksSheetMap[parseInt(key) + 1]?.mark_allocation || 0;

            const questionData = this.props.assessmentQuestions[key];
            const answerMap = JSON.parse(
              this.props.contentMap[questionData.question_id] || "{}"
            );
            const answer = JSON.parse(this.props.answerContents[key] || "[]");
            const blocks = answerMap?.blocks || [];
            const hasText = blocks.some(block => block.text && block.text.trim().length > 0);

            let tempQuestion = EditorState.createWithContent(convertFromRaw(states[0]));

            // Optional: parse guidance
            let guidanceEditorContent = null;
            try {
              const guidance = questionData?.guidence;
              if (guidance) {
                const guidanceContent = JSON.parse(guidance);
                guidanceEditorContent = EditorState.createWithContent(convertFromRaw(guidanceContent[0]));
              }
            } catch (err) {
              console.error("Failed to parse guidance", err);
            }

            return (
              <div className="ml-5" key={`sub-question-${key}`}>
                {/* Sub-question passage */}
                {questionData?.is_passage && questionData?.passage_id && questionData?.passage_content && (
                  <>
                    <div className="mb-5 mt-5">
                      <ViewEditor editorState={this.getQuestionPassageContent(questionData.passage_content)} />
                    </div>
                    <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
                  </>
                )}

                {/* Sub-question title and marks */}
                <div className="row mb-5">
                  <div className="col-md-11 col-11">
                    <h4 className="m-0 all-questions-title">
                      <h5 className="number-wrap m-0 answer-sheet-text">{j + 1}.</h5>
                      <h5 className="col-md-12 col-12 answer-sheet-text">
                        <ViewEditor editorState={tempQuestion} />
                      </h5>
                    </h4>
                  </div>
                  <div className="col-md-1 col-1 d-flex align-items-center justify-content-end">
                    {/* Label Section */}
                    {this.props.sections.length > 0 && 
                    <div>
                      {questionData?.is_optional && this.getSelectedQuestionIdsForMarking().has(questionData?.question_id) && (
                        <span className="badge badge-success mr-2">Optional Question - Marks included in Total</span>
                      )}
                      {questionData?.is_optional && !this.getSelectedQuestionIdsForMarking().has(questionData?.question_id) && (
                        <span className="badge badge-primary mr-2">Optional Question - Marks omitted in Total</span>
                      )}
                    </div>}
                    <h5 className="m-0 stu-variant-class label label-lg label-success label-inline">
                      {this.props.candidateAnswerMap[questionData.question_id]?.mark_obtained || 0}/{marks}
                    </h5>
                  </div>
                </div>

                {/* Answer and model answer */}
                <div className="col-md-12">
                  <div className="row mt-3">
                    <div className="col-md-2 col-12">
                      <h6 className="model-guidance-text mt-4">Your Answer:</h6>
                    </div>
                    <div className="col-md-10 col-12 d-flex align-items-center">
                      {hasText ? (
                        <p className="m-0 overflow-hidden answer-sheet-text">
                          <Editor
                            editorState={EditorState.createWithContent(convertFromRaw(answerMap))}
                            toolbarClassName="hide-toolbar"
                            toolbarHidden={true}
                            readOnly={true}
                          />
                        </p>
                      ) : (
                        <p className="stu-variant-class label label-lg label-danger label-inline answer-sheet-text">
                          Not Answered
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2 col-12">
                      <h6 className="model-guidance-text mt-4">Model Answer:</h6>
                    </div>
                    <div className="col-md-10 col-12">
                      <p className="answer-sheet-text">
                        <Editor
                          editorState={EditorState.createWithContent(convertFromRaw(answer[0]))}
                          toolbarClassName="hide-toolbar"
                          toolbarHidden={true}
                          readOnly={true}
                        />
                      </p>
                    </div>
                  </div>

                  {/* Optional: Guidance display */}
                  {guidanceEditorContent && (
                    <div className="row">
                      <div className="col-md-2 col-12">
                        <h6 className="model-guidance-text mt-4">Marking Guidance:</h6>
                      </div>
                      <div className="col-md-10 col-12">
                        <div className="card p-3">
                          <p className="answer-sheet-text">
                            <ViewEditor editorState={guidanceEditorContent} />
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
              </div>
            );
          })}
        </div>
      );
    } else if (question_type === questionTypeConstants.MCQ.name) {
      states.shift()
      states.forEach((state) => {
        tempAnswerStates.push(
          EditorState.createWithContent(convertFromRaw(state))
        )
      })
      return (
        <div>
          {this.props.assessmentQuestions[i]?.is_passage === true && this.props.assessmentQuestions[i]?.passage_id !== null && this.props.assessmentQuestions[i]?.passage_content !== undefined &&
            <div className="mb-5 mt-5">
              <ViewEditor
                editorState={this.getQuestionPassageContent(this.props.assessmentQuestions[i]?.passage_content)}
              />
            </div>
          }
          <div className="row">
            <div className="col-md-9 col-9">
              <h5 className="m-0">
                {el.mainAnsCount}.
                {/* {el.mainAnsCount}. {this.props.assessmentQuestions[i]?.title} */}
              </h5>
            </div>
            <div className="col-md-3 col-3 d-flex align-items-center justify-content-end">
              <p className="stu-variant-class label label-lg label-success label-inline">
                {/* Label Section */}
                {this.props.sections.length > 0 && 
                <div>
                  {isOptional && isIncluded && (
                    <span className="badge badge-success mr-2">Optional Question - Marks included in Total</span>
                  )}
                  {isOptional && !isIncluded && (
                    <span className="badge badge-primary mr-2">Optional Question - Marks omitted in Total</span>
                  )}
                </div>}
                {/* Marks:{" "} */}
                {
                  this.props.candidateAnswerMap[
                    this.props.assessmentQuestions[i]?.question_id
                  ]?.mark_obtained
                }
                /{mark_allocation}
              </p>
            </div>
            <h3 className="m-0 overflow-hidden">
              <p className="col-md-12 col-12 answer-sheet-text">
                <ViewEditor editorState={tempQuestionState} />
              </p>
            </h3>
          </div>
          {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
        </div>
      )
    } else if (question_type === questionTypeConstants.SUBMISSION.name) {
      return (
        <div>
          {this.props.assessmentQuestions[i]?.is_passage === true && this.props.assessmentQuestions[i]?.passage_id !== null && this.props.assessmentQuestions[i]?.passage_content !== undefined &&
            <div className="mb-5 mt-5">
              <ViewEditor
                editorState={this.getQuestionPassageContent(this.props.assessmentQuestions[i]?.passage_content)}
              />
            </div>
          }
          <div className="row mb-5">
            <div className="col-md-9 col-9">
              <h5 className="m-0">
                {el.mainAnsCount}.
                {/* {el.mainAnsCount}. {this.props.assessmentQuestions[i]?.title} */}
              </h5>
            </div>
            <div className="col-md-3 col-3 d-flex align-items-center justify-content-end">
              <p className="stu-variant-class label label-lg label-success label-inline">
                {/* Label Section */}
                {this.props.sections.length > 0 && 
                <div>
                  {isOptional && isIncluded && (
                    <span className="badge badge-success mr-2">Optional Question - Marks included in Total</span>
                  )}
                  {isOptional && !isIncluded && (
                    <span className="badge badge-primary mr-2">Optional Question - Marks omitted in Total</span>
                  )}
                </div>}
                {/* Marks:{" "} */}
                {
                  this.props.candidateAnswerMap[
                    this.props.assessmentQuestions[i]?.question_id
                  ]?.mark_obtained
                }
                /{mark_allocation}
              </p>
            </div>
          </div>
          <h3 className="m-0 overflow-hidden">
            <p className="col-md-12 col-12 answer-sheet-text">
              <ViewEditor editorState={tempQuestionState} />
            </p>
          </h3>
          {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
        </div>
      )
    }
  }

  getAssessorAnswerInEditor(question, i) {
    var question_type = this.props.assessmentQuestions[i].question_type
    var answer =
      this.props.contentMap[this.props.assessmentQuestions[i].question_id]
    var answer_type = this.props.assessmentQuestions[i].answer_type_id;
    let states = JSON.parse(this.props.questionContents[i])
    var no_ans = states.length - 1
    var tempAnswerStates = []
    // let container = "".concat(
    //   this.props.assessmentQuestions[i].created_by,
    //   "-sa-",
    //   this.props.assessmentQuestions[i].answer
    // )
    let container= config.storageBlobConfigs.containerName;
    if (question_type === questionTypeConstants.MCQ.name) {
      var res = this.props.answerContents[i]?.split(",")
      var anyBoxesChecked = [],
          ans
      if (answer) {
        answer = JSON.parse(answer)
        
        for (var n = 0; n < no_ans; n++) {
          anyBoxesChecked.push(false)
        }
        for (ans in answer) {
          anyBoxesChecked[answer[ans]] = true
        }
      }
      states.shift()
      states.forEach((state) => {
        tempAnswerStates.push(
          EditorState.createWithContent(convertFromRaw(state))
        )
      })
      return (
        <div>
          <div className="RichEditor-root py-0">
            {tempAnswerStates?.map((answer, j) => {
              let val = "0"
              if (parseFloat(res[j]) > 0) {
                val = "1"
              } else if (parseFloat(res[j]) < 0) {
                val = "-1"
              }
              return (
                <div
                  className={`row d-flex align-items-center ${
                    parseFloat(res[j])
                      ? "answersheet-correct"
                      : anyBoxesChecked[j]
                      ? "answersheet-wrong"
                      : ""
                  }`}
                >
                  <div className="col-md-1 col-1">
                    {answer_type === questionMCQAnswerTypeConstants.One.id ? 
                      <RadioInline className="col-md-1">
                        {/* <CheckBox key={j} checked={anyBoxesChecked[j]} className="correct-color" />
                        <CheckBox key={j} checked={parseFloat(res[j]) > 0} /> */}
                        <Radio
                          key={j}
                          checked={anyBoxesChecked[j]}
                          style={{
                            color: "#5458AF",
                          }}
                        />
                      </RadioInline>
                      :
                      <CheckBoxInline className="col-md-1">
                        {/* <CheckBox key={j} checked={anyBoxesChecked[j]} className="correct-color" />
                        <CheckBox key={j} checked={parseFloat(res[j]) > 0} /> */}
                        <CheckBox
                          key={j}
                          checked={anyBoxesChecked[j]}
                          style={{
                            color: "#5458AF",
                          }}
                        />
                      </CheckBoxInline>
                    }
                  </div>
                  <div className="col-md-11 col-11">
                    <div className="row d-flex align-items-center">
                      <div className="col-md-11 col-11 answer-sheet-text">
                        <Editor
                          editorState={answer}
                          toolbarHidden={true}
                          toolbarClassName="hide-toolbar"
                          readOnly={true}
                        />
                      </div>
                      <div className="col-md-1 col-1 d-flex justify-content-end">
                        <div className={this.getColor(val)}>
                          {parseFloat(res[j]) > 0 ? "✔" : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <div class="separator my-5"></div>
        </div>
      )
    } else if (question_type === questionTypeConstants.DESCRIPTIVE.name) {
      var answer = JSON.parse(this.props.answerContents[i])
      return (
        <div>
          <h3 className="m-0 overflow-hidden">
            <div className="row mt-3">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Model Answer:</h6>
              </div>
              <div className="col-md-10 col-12">
                <p className="answer-sheet-text">
                  <Editor
                    editorState={EditorState.createWithContent(
                      convertFromRaw(answer[0])
                    )}
                    toolbarClassName="hide-toolbar"
                    toolbarHidden={true}
                    readOnly={true}
                  />
                </p>
              </div>
            </div>
          </h3>
          {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
        </div>
      )
    } else if (question_type === questionTypeConstants.SUBMISSION.name) {
      let attachmentName = this.props.answerContents[i]
        .replace(/^\[(.+)\]$/, "$1")
        .replace(/"\"$/, "$1")
        .split(",")
      if (attachmentName.length > 0) {
        let itemList = []
        {
          attachmentName.map((attach) => {
            if (attach.replace(/"/g, "") != "[]") {
              itemList.push(
                <div>
                  <div className="row">
                    <div className="col-md-3 col-3 px-0">
                      <AttachmentButton
                        className="btn mr-2 submission-document"
                        btnIconStyle="flaticon-interface-3"
                        // inlineStyle={{ innerWidth: "400px" }}
                        btnName={attach.replace(/"/g, "")}
                        onClick={(e) => {
                          this.onDownloadAttachment(
                            e,
                            container,
                            attach.replace(/"/g, "")
                          )
                        }}
                      />
                    </div>
                  </div>
                </div>
              )
            }
          })
        }
        return (
          <div>
            <div className="row mt-3">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Model Answer:</h6>
              </div>
              <div className="RichEditor-root col-md-10 p-0">{itemList}</div>
            </div>
            {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
          </div>
        )
      } else {
        return (
          <div>
            <div className="row mt-3">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Model Answer:</h6>
              </div>
              <div className="RichEditor-root col-md-10">
                No Answer Uploaded!
              </div>
            </div>
            {/* <div class="separator separator-dashed separator-border-2 my-5"></div> */}
          </div>
        )
      }
    }
  }

  getAssessorAnswerGuidanceInEditor(question, i) {
    var guidance = this.props.assessmentQuestions[i].guidence

    var guidanceContent = JSON.parse(guidance);

    let guidanceEditorContent = EditorState.createWithContent(
      convertFromRaw(guidanceContent[0])
    )

    var question_type = this.props.assessmentQuestions[i].question_type

    if (question_type === questionTypeConstants.MCQ.name && guidance) {
      return (
        <div>
          <div className="row">
            <div className="col-md-2 col-12 d-flex align-items-center">
              <h6 className="model-guidance-text">Marking Guidance:</h6>
            </div>
            <div className="col-md-10 col-12">
              <div className="card p-3">
                <p className="answer-sheet-text">
                  {guidance ? (
                    <ViewEditor editorState={guidanceEditorContent} />
                  ) : (
                    <div>
                      <p className="answer-sheet-text">
                        No marking guidance given for this question
                      </p>
                    </div>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="separator mt-4 mb-4"></div>
        </div>
      )
    } else if (
      question_type === questionTypeConstants.DESCRIPTIVE.name &&
      guidance
    ) {
      return (
        <div>
          <div className="row">
            <div className="col-md-2 col-12 d-flex align-items-center">
              <h6 className="model-guidance-text">Marking Guidance:</h6>
            </div>
            <div className="col-md-10 col-12">
              <div className="card p-3">
                <p className="answer-sheet-text">
                  {guidance ? (
                    <ViewEditor editorState={guidanceEditorContent} />
                  ) : (
                    <div>
                      <p className="answer-sheet-text">
                        No marking guidance given for this question
                      </p>
                    </div>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="separator mt-4 mb-4"></div>
        </div>
      )
    } else if (
      question_type === questionTypeConstants.SUBMISSION.name &&
      guidance
    ) {
      return (
        <div>
          <div className="row">
            <div className="col-md-2 col-12 d-flex align-items-center">
              <h6 className="model-guidance-text">Marking Guidance:</h6>
            </div>
            <div className="col-md-10 col-12">
              <div className="card p-3">
                <p className="answer-sheet-text">
                  {guidance ? (
                    <ViewEditor editorState={guidanceEditorContent} />
                  ) : (
                    <div>
                      <p className="answer-sheet-text">
                        No marking guidance given for this question
                      </p>
                    </div>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="separator mt-4 mb-4"></div>
        </div>
      )
    }
  }

  getAnswerInEditor(question, i) {
    var question_type = this.props.assessmentQuestions[i].question_type
    var answer =
      this.props.contentMap[this.props.assessmentQuestions[i].question_id]
    let states = JSON.parse(this.props.questionContents[i])
    var no_ans = states.length - 1
    var tempAnswerStates = []
    if (question_type === questionTypeConstants.DESCRIPTIVE.name) {
      if (answer) {
        var answerState = JSON.parse(answer)
        const blocks = answerState?.blocks || [];
        const hasText = blocks.some(block => block.text && block.text.trim().length > 0);
        return (
          <div>
            <div className="row">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Your Answer:</h6>
              </div>
              <div className="col-md-10 col-12 d-flex align-items-center">
                {hasText ? (
                  <p className="m-0 overflow-hidden answer-sheet-text">
                    <Editor
                      editorState={EditorState.createWithContent(
                        convertFromRaw(answerState)
                      )}
                      toolbarClassName="hide-toolbar"
                      toolbarHidden={true}
                      readOnly={true}
                    />
                  </p>
                ) : (
                  <p className="stu-variant-class label label-lg label-danger label-inline answer-sheet-text">
                    Not Answered
                  </p>
                )}
              </div>
            </div>
            <div class="separator my-5"></div>
          </div>
        )
      }
    } else if (question_type === questionTypeConstants.SUBMISSION.name) {
      let attachmentName = answer
        .replace(/^\[(.+)\]$/, "$1")
        .replace(/"\"$/, "$1")
        .split(",")
      const container = "".concat(
        this.props.candidate.candidate_id,
        "-",
        this.props.assessmentQuestions[i].question_id
      )
      const container_name = config.storageBlobConfigs.containerName;
      
      if (attachmentName[0] !== "[]") {
        let itemList = []
        {
          attachmentName.map((attach) => {
            if (attach.replace(/"/g, "") != "[]") {
              itemList.push(
                <div className="row">
                  <AttachmentButton
                    className="btn mr-2 submission-document"
                    btnIconStyle="flaticon-interface-3"
                    btnName={attach.replace(/"/g, "")}
                    onClick={(e) => {
                      this.onDownloadAttachment(
                        e,
                        container_name,
                        container + "-" + attach.replace(/"/g, "")
                      )
                    }}
                  />
                </div>
              )
            }
          })
        }
        return (
          <div>
            <div className="row">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Your Answer:</h6>
              </div>
              <div className="RichEditor-root col-md-10 p-0">{itemList}</div>
            </div>
            <div class="separator my-5"></div>
          </div>
        )
      } else {
        return (
          <div>
            <div className="row">
              <div className="col-md-2 col-12">
                <h6 className="model-guidance-text mt-4">Your Answer:</h6>
              </div>
              <p className="RichEditor-root d-flex align-items-center stu-variant-class label label-lg label-danger label-inline mx-4 my-2 answer-sheet-text">
                No Answer Uploaded!
              </p>
            </div>
            <div class="separator my-5"></div>
          </div>
        )
      }
    }
  }

  getQuestionanswer(question_number) {
    let answer = this.state.marksSheetMap[question_number].correctAnswer
    return answer
  }

  // getSumOfMarkAllocation() {
  //   let totalSum = 0
  //   Object.keys(this.state.marksSheetMap).forEach((questionNumber) => {
  //     const marksData = this.state.marksSheetMap[questionNumber]
  //     const correctAnswerMarkAllocation = marksData.mark_allocation || 0
  //     totalSum += correctAnswerMarkAllocation
  //   })
  //   return totalSum
  // }

  getSumOfMarkAllocation() {
    const assessmentQuestions = this.props?.assessmentQuestions || [];
    const sectionMeta = this.props?.sections || [];

    let totalMarks = 0;

    if (Array.isArray(sectionMeta) && sectionMeta.length > 0) {
      sectionMeta.forEach(section => {
        const {
          section_id,
          allow_optional_questions,
          no_of_questions_to_answer
        } = section;

        // Get all questions in this section
        const allSectionQuestions = assessmentQuestions.filter(q => q.section_id === section_id);

        // Build a question map for quick lookup by ID
        const questionMap = new Map();
        allSectionQuestions.forEach(q => questionMap.set(q.question_id, q));

        // Helper to calculate total marks of a main question + its sub-questions
        const calculateGroupMark = (mainQuestion) => {
          let total = mainQuestion.mark_allocation || 0;

          if (mainQuestion.sub_questions) {
            mainQuestion.sub_questions.split(',').forEach(idStr => {
              const id = parseInt(idStr.trim());
              const subQ = questionMap.get(id);
              if (subQ) {
                total += subQ.mark_allocation || 0;
              }
            });
          }

          return total;
        };

        if (!allow_optional_questions) {
          // All required, sum all main and sub-question marks
          allSectionQuestions.forEach(q => {
            if (q.is_subquestion !== "true") {
              totalMarks += calculateGroupMark(q);
            }
          });
        } else {
          // Separate required and optional main questions
          const requiredQuestions = allSectionQuestions.filter(q => !q.is_optional && q.is_subquestion !== "true");
          const optionalQuestions = allSectionQuestions.filter(q => q.is_optional && q.is_subquestion !== "true");

          const optionalToConsider = no_of_questions_to_answer - requiredQuestions.length;

          // Add required question group marks
          requiredQuestions.forEach(q => {
            totalMarks += calculateGroupMark(q);
          });

          // Sort optional questions by group total marks descending
          const topOptionalGroups = optionalQuestions
            .map(q => ({ q, groupMark: calculateGroupMark(q) }))
            .sort((a, b) => b.groupMark - a.groupMark)
            .slice(0, optionalToConsider);

          // Add their marks
          topOptionalGroups.forEach(({ groupMark }) => {
            totalMarks += groupMark;
          });
        }
      });
    }

    return totalMarks;
  }

  // getSumOfMarkObtained() {
  //   let totalMarksObtained = 0
  //   for (let i = 0; i < this.props.assessmentQuestions?.length; i++) {
  //     const question = this.props.assessmentQuestions[i]
  //     const questionId = question?.question_id
  //     const markObtained =
  //       this.props.candidateAnswerMap?.[questionId]?.mark_obtained || 0
  //     totalMarksObtained += markObtained
  //   }
  //   return totalMarksObtained
  // }

  getSumOfMarkObtained() {
    const candidate_answers = this.props?.candidateAnswerMap || [];
    const assessmentQuestions = this.props?.assessmentQuestions || [];
    const sectionMeta = this.props?.sections || [];

    let total = 0;

    if (Array.isArray(sectionMeta) && sectionMeta.length > 0) {
      sectionMeta.forEach(section => {
        const {
          section_id,
          allow_optional_questions,
          no_of_questions_to_answer
        } = section;

        const allSectionQuestions = assessmentQuestions.filter(q => q.section_id === section_id);

        // Map for quick lookup
        const questionMap = new Map();
        allSectionQuestions.forEach(q => questionMap.set(q.question_id, q));

        // Helper to calculate total received marks for main + sub-questions
        const calculateGroupReceivedMark = (mainQuestion) => {
          let groupTotal = candidate_answers[mainQuestion.question_id]?.mark_obtained || 0;

          if (mainQuestion.sub_questions) {
            mainQuestion.sub_questions.split(',').forEach(idStr => {
              const id = parseInt(idStr.trim());
              const subMark = candidate_answers[id]?.mark_obtained;
              if (typeof subMark === "number") {
                groupTotal += subMark;
              }
            });
          }

          return groupTotal;
        };

        if (!allow_optional_questions) {
          // All questions are required: sum all main + sub-question marks
          allSectionQuestions.forEach(q => {
            if (q.is_subquestion !== "true") {
              total += calculateGroupReceivedMark(q);
            }
          });
        } else {
          // Optional logic
          const requiredQuestions = allSectionQuestions.filter(q => !q.is_optional && q.is_subquestion !== "true");
          const optionalQuestions = allSectionQuestions.filter(q => q.is_optional && q.is_subquestion !== "true");

          const optionalToConsider = no_of_questions_to_answer - requiredQuestions.length;

          // Required groups
          requiredQuestions.forEach(q => {
            total += calculateGroupReceivedMark(q);
          });

          // Optional groups sorted by mark
          const topOptionalGroups = optionalQuestions
            .map(q => ({ q, groupMark: calculateGroupReceivedMark(q) }))
            .sort((a, b) => b.groupMark - a.groupMark)
            .slice(0, optionalToConsider);

          topOptionalGroups.forEach(({ groupMark }) => {
            total += groupMark;
          });
        }
      });

      this.getSelectedQuestionIdsForMarking();
      return total;
    }

    // Fallback if no sectionMeta
    return assessmentQuestions.reduce((sum, q) => {
      const mark = candidate_answers[q.question_id]?.mark_obtained;
      return typeof mark === "number" ? sum + mark : sum;
    }, 0);
  }

  getSelectedQuestionIdsForMarking() {
    const questions = this.props.assessmentQuestions || [];
    const sections = this.props.sections || [];
    const answerMap =  this.props.candidateAnswerMap || {};
    const selectedQuestionIds = new Set();

    if (sections.length === 0) return selectedQuestionIds;

    // Create a lookup for quick access
    const questionMap = new Map();
    questions.forEach(q => questionMap.set(q.question_id, q));

    sections.forEach(section => {
      const { section_id, no_of_questions_to_answer } = section;
      const sectionQuestions = questions.filter(q => q.section_id === section_id);

      const requiredQuestions = sectionQuestions.filter(q => !q.is_optional && q.is_subquestion !== "true");
      const optionalQuestions = sectionQuestions.filter(q => q.is_optional && q.is_subquestion !== "true");

      const optionalToConsider = no_of_questions_to_answer - requiredQuestions.length;

      // Add required questions + their sub-questions
      requiredQuestions.forEach(mainQ => {
        selectedQuestionIds.add(mainQ.question_id);

        if (mainQ.sub_questions) {
          mainQ.sub_questions.split(',').forEach(idStr => {
            const subId = parseInt(idStr.trim());
            selectedQuestionIds.add(subId);
          });
        }
      });

      // Skip if no optional questions
      if (optionalQuestions.length === 0 || optionalToConsider <= 0) return;

      // Calculate group marks for optional questions
      const optionalGroups = optionalQuestions.map(mainQ => {
        let totalMark = answerMap[mainQ.question_id]?.mark_obtained || 0;

        if (mainQ.sub_questions) {
          mainQ.sub_questions.split(',').forEach(idStr => {
            const subId = parseInt(idStr.trim());
            const subMark = answerMap[subId]?.mark_obtained;
            if (typeof subMark === "number") {
              totalMark += subMark;
            }
          });
        }

        return { mainQ, totalMark };
      });

      // Sort and pick top N groups
      const topOptionalGroups = optionalGroups
        .sort((a, b) => b.totalMark - a.totalMark)
        .slice(0, optionalToConsider);

      // Add selected optional main + sub-question IDs
      topOptionalGroups.forEach(({ mainQ }) => {
        selectedQuestionIds.add(mainQ.question_id);

        if (mainQ.sub_questions) {
          mainQ.sub_questions.split(',').forEach(idStr => {
            const subId = parseInt(idStr.trim());
            selectedQuestionIds.add(subId);
          });
        }
      });
    });

    return selectedQuestionIds;
  }

  renderQuestion = (question, index) => {
    return (
      <>
        {this.getContentInEditor(question, index)}
        {this.getAnswerInEditor(question, index)}
        {this.getAssessorAnswerInEditor(question, index)}
        {this.getAssessorAnswerGuidanceInEditor(question, index)}
      </>
    );
  };

  render() {
    return (
      <>
        <div style={{ overflowY: "auto", height: "90vh" }}>
          <ContentWrapper>
            {this.props.answerContents.length &&
            this.props.questionContents.length &&
            !this.state.paperViewLoading ? (
            <Card>
              <CardHeader>
                <CardTitle
                  cardLabel={this.props.assessment?.title + " - Answer Sheet"}
                />
                <div className="d-flex justify-content-end">
                  <h4 className="stu-variant-class label label-lg label-light-success label-inline border border-primary p-3 m-0 mr-2">
                    Total Marks: {this.getSumOfMarkObtained()}/
                    {this.getSumOfMarkAllocation()}
                  </h4>
                  {/* <div className="d-flex align-items-center justify-content-end">
                    <h4 className="text-white font-weight-bold p-3 mb-3" style={addBtnStyle}>
                      Total Marks: {this.getSumOfMarkObtained()}/
                      {this.getSumOfMarkAllocation()}
                    </h4>
                  </div> */}
                  <Button
                    variant="contained"
                    style={addBtnStyle}
                    onClick={() => {
                      // this.props.history.push({
                      //   pathname: "/paper-grade-report",
                      //   state: {
                      //     mid: sessionStorage.getItem("enrolled_paper_list_mid"),
                      //     pid: sessionStorage.getItem("pid"),
                      //     lg_user_id: sessionStorage.getItem("lg_user_id"),
                      //     lg_user_table_id:
                      //       sessionStorage.getItem("lg_user_table_id"),
                      //     flg_list_active:
                      //       sessionStorage.getItem("flg_list_active"),
                      //     form_display_title:
                      //       sessionStorage.getItem("form_display_title"),
                      //   },
                      // });
                      this.props.hidePaperReview()
                    }}
                  >
                    Back
                  </Button>
                </div>
                {this.props.sections.length > 0 && <div className="text-center mb-4 text-muted">
                  <small>
                    <strong>Note:</strong> For optional questions, Final marks count only the highest scoring answers up to the required number.
                  </small>
                </div>}
              </CardHeader>
                <>
                <AssessmentInfoCard details={this.props.assessment_details} />

                {this.props.sections?.length > 0 ? (
                  <div className="mt-3">
                    {Object.entries(this.state.groupedQuestions).sort(([, a], [, b]) => a.part_display_order - b.part_display_order).map(([partId, part]) => (
                      <div key={`part-${partId}`} className="mb-5 p-4 border rounded bg-light">
                        <h2 className="text-primary mb-4">{part.name}</h2>

                        {part.allow_part_instruction && part.part_instruction && (
                          <div className="mb-3">
                            <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
                              {part.part_instruction.split('\n').map((line, idx) => (
                                <li key={`part-inst-${idx}`}>{line.replace(/^•\s*/, '').trim()}</li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {Object.entries(part.sections).sort(([, a], [, b]) => a.section_display_order - b.section_display_order).map(([sectionId, section]) => {
                          let mainAnsCount = 0;
                          return (
                            <div key={`section-${sectionId}`} className="mb-4 p-3 border rounded bg-white">
                              <h4 className="text-secondary">{section.title}</h4>

                              {section.allow_section_instruction && section.section_instruction && (
                                <div className="mb-3">
                                  <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
                                    {section.section_instruction.split('\n').map((line, idx) => (
                                      <li key={`section-inst-${idx}`}>{line.replace(/^•\s*/, '').trim()}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <div className="question-list">
                                {section.questions.map(({ data, index }) => {
                                  if (data.is_subquestion !== "true") {
                                    mainAnsCount++;
                                  }
                                  const altQuestion = { ...data, mainAnsCount };

                                  return (
                                    <div key={index}>
                                      {this.renderQuestion(altQuestion, index)}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="mt-3">
                    {this.props.assessmentQuestions.map((question, i) => {
                      let mainAnsCount = 0;
                      if (question.is_subquestion !== "true") {
                        mainAnsCount++;
                      }
                      const altQuestion = { ...question, mainAnsCount };

                      return (
                        <div
                          className={
                            this.props.assessmentQuestions[i]?.is_subquestion
                              ? ""
                              : "question-container"
                          }
                          key={i}
                        >
                          {this.getContentInEditor(altQuestion, i)}
                          {this.getAnswerInEditor(altQuestion, i)}
                          {this.getAssessorAnswerInEditor(altQuestion, i)}
                          {this.getAssessorAnswerGuidanceInEditor(altQuestion, i)}
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            </Card>
            ) : (
              <Spinner id="show" text="Loading Answer Sheet..." />
            )}
          </ContentWrapper>
        </div>
      </>
    )
  }
}

const mapStateToActions = {
  getTestQuestionContent: getTestQuestionContent,
  getAllQuestionContents: getAllQuestionContents,
  getAllAnswerContents: getAllAnswerContents,
  getAllCandidateAnswerContents: getAllCandidateAnswerContents,
  getCandidateAnswers: getCandidateAnswers,
  getAutoShuffleFlag: getAutoShuffleFlag,
  loadQuestions: loadQuestions,
  loadAssessmentQuestions: loadAssessmentQuestions,
  openAssessment: openAssessment,
  clearCandidateAnswers: clearCandidateAnswers,
}

function mapStateToProps(state) {
  return {
    test_loading: state.testReducer.loading,
    test_error: state.testReducer.error,
    questions: state.testReducer.questions,
    sections: state.testReducer.sections,
    assessment_details: state.testReducer.assessment_details,
    assessmentQuestions: state.testReducer.assessmentQuestions,
    auto_shuffle: state.testReducer.auto_shuffle,

    content_error: state.testPageReducer.error,
    content_success: state.testPageReducer.success,
    content_loading: state.testPageReducer.loading,
    questionContents: state.testPageReducer.questionContents,

    submission_uploading: state.submissionReducer.loading,
    submission_error: state.submissionReducer.error,
    submission_success: state.submissionReducer.success,

    candidate_id: state.validationReducer.candidate_id,
    start_time: state.validationReducer.start_time,
    exam_duration: state.validationReducer.exam_duration,

    contentMap: state.testReducer.candidateAnswerContentMap,
    candidateAnswerContents: state.testReducer.candidateAnswerContents,
    answerContents: state.testReducer.answerContents,
    candidateAnswers: state.testReducer.candidateAnswers,
    candidateAnswerMap: state.testReducer.candidateAnswerMap,
    candidate: state.testReducer.candidate,

    gradeError: state.gradeReducer.error,
    gradeLoading: state.gradeReducer.loading,
  }
}

export default connect(mapStateToProps, mapStateToActions)(PaperReview)
